export default __webpack_public_path__ + "static/iconography-image-l-9a9d576be6136043ffe609377b64a0aced7ae7505f00e9bc9b58b7f6e7cd6fd3.png";